module.exports = __webpack_public_path__ + "img/PISAFARMACEUTICACHILESA.89a52162.jpg";